import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

const ROUTES = [
  "/copilot",
  "/catalog",
  "/workflows",
  "/runs",
  "/knowledge",
  "/integrations",
  "/teamcenter",
  "/hosts",
  "/audit",
];

/**
 * Global keyboard shortcuts:
 *  - Cmd/Ctrl + 1..9 → jump to sidebar items in order
 *  - Cmd/Ctrl + /    → focus copilot chat input (dispatches custom event)
 */
export function useGlobalShortcuts() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const meta = e.metaKey || e.ctrlKey;
      if (!meta) return;
      // ignore when typing in inputs, except for the explicit shortcuts below
      if (e.key === "/") {
        e.preventDefault();
        navigate({ to: "/copilot" });
        // give the route a tick, then ask the chat input to focus
        setTimeout(() => window.dispatchEvent(new CustomEvent("copilot:focus-input")), 60);
        return;
      }
      if (/^[1-9]$/.test(e.key)) {
        const idx = parseInt(e.key, 10) - 1;
        const target = ROUTES[idx];
        if (target) {
          e.preventDefault();
          navigate({ to: target });
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);
}
